import { render, staticRenderFns } from "./ParetoParos.vue?vue&type=template&id=516be02c&scoped=true&"
import script from "./ParetoParos.vue?vue&type=script&lang=js&"
export * from "./ParetoParos.vue?vue&type=script&lang=js&"
import style0 from "./ParetoParos.vue?vue&type=style&index=0&id=516be02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516be02c",
  null
  
)

export default component.exports